module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_hospital07-31d5a2aadeff5653595372405bfa924d.png";